'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventPage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _config = require('../config.js');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventPage(_ref) {
  var event = _ref.event,
      location = _ref.location,
      push = _ref.push;

  var backButtonAction = function backButtonAction() {
    push({ pathname: '/' });
  };

  return _react2.default.createElement(
    'div',
    { className: 'EventPage' },
    _react2.default.createElement(_caligramReact.EventMeta, { event: event, siteName: _config2.default.app.title, twitterUsername: _config2.default.app.meta.property['twitter:creator'] }),
    _react2.default.createElement(_caligramReact.EventDetail, { backButtonAction: backButtonAction, event: event, mapApiKey: _config2.default.app.googleMaps.apiKey, selectedDate: location.query.date })
  );
}

EventPage.propTypes = {
  event: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.any,
  params: _react.PropTypes.object.isRequired
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EventPage.js
// module id = 1163
// module chunks = 0